export const PASSWORD_RESET = 'events/PASSWORD_RESET';

/**
 * @param password
 * @return {{type: string, payload: {password:*}}}
 */
export const passwordReset = (password) => ({
  type: PASSWORD_RESET,
  payload: { password },
});
